import React from 'react'
import PropTypes from 'prop-types'

import {
  Box, ListItem, Text,
} from '@domain-group/suit-theme'

const CustomInvoiceListItem = (props) => {
  const { colour, boxProps, text } = props

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        fontSize: 'small',
        paddingY: 'medium',
        ...boxProps,
      }}
      disableHover
    >
      <Box justifyContent="space-between">
        <Text color="bodyFontColor" variant="ellipsis">
          {text}
        </Text>

        <Text color="faintGrey" variant="ellipsis">
          {colour ? `(${colour})` : '(No Colour Set)'}
        </Text>
      </Box>
    </ListItem>
  )
}

CustomInvoiceListItem.propTypes = {
  colour: PropTypes.string,
  boxProps: PropTypes.object,
  text: PropTypes.string,
}

export default CustomInvoiceListItem
